import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE } from "../data/site";

/**
 * SEO wrapper — sets title, meta description, canonical, OG/Twitter tags and
 * hreflang alternates (fr ↔ en, x-default → fr).
 * `path` is the CURRENT page path ("/en/..." for English pages); the French
 * and English alternates are derived from it automatically.
 */
export default function Seo({
    title,
    description,
    path = "/",
    image,
    jsonLd,
    lang = "fr",
}) {
    const isEn = lang === "en";
    const frPath = isEn ? path.replace(/^\/en/, "") || "/" : path;
    const enPath = frPath === "/" ? "/en" : `/en${frPath}`;
    const url = `${SITE.siteUrl}${isEn ? enPath : frPath}`;
    const frUrl = `${SITE.siteUrl}${frPath}`;
    const enUrl = `${SITE.siteUrl}${enPath}`;
    const ogImage = image || SITE.logoPrimaryUrl;

    return (
        <Helmet>
            <html lang={lang} />
            <title>{title}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE.name} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={url} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:locale" content={isEn ? "en_US" : "fr_FR"} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />

            {/* Hreflang — FR default + EN */}
            <link rel="alternate" href={frUrl} hrefLang="fr" />
            <link rel="alternate" href={enUrl} hrefLang="en" />
            <link rel="alternate" href={frUrl} hrefLang="x-default" />

            {jsonLd && (
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            )}
        </Helmet>
    );
}
